import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Link from '@rad/components/utility/link';
import { useRouting, useRoutingConfig } from '@rad/hooks/useRouting';
// "Back to …" only when it goes back: it steps back to the page behind this one in history, as the
// browser's Back would, so that page returns as the visitor left it and Back afterwards does not bring
// them here again. With nothing behind, an onward link named for where it leads stands in.
const BackButton = (props) => {
    const strategy = useRoutingConfig();
    const [, navigate] = useRouting();
    const back = props.back;
    // Link prevents the default for the clicks it handles itself; the rest, such as a click opening a
    // new tab, the browser handles.
    const onClick = (event) => {
        if (!event.defaultPrevented)
            return;
        if (!strategy.returnToOrigin())
            navigate(back.href);
    };
    return _jsx(_Fragment, { children: back.kind === 'back'
            ? _jsxs(Link, { href: back.href, className: props.className, onClick: onClick, children: [_jsx("i", { className: "bi bi-arrow-left me-1" }), "Back to ", back.label] })
            : _jsxs(Link, { href: back.href, className: props.className, children: [_jsx("i", { className: `bi ${back.icon} me-1` }), back.label] }) });
};
export default BackButton;
